import { IAutomationAppComponent } from "../../types";
import { schema} from "./types";
import { OverviewPanel,OperatorPanel, ConfigurationPanel } from '.';
import { MdOutlineWindow } from "react-icons/md";
import { InsightsPanel } from "./InsightsPanel";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: MdOutlineWindow,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    InsightsPanel: InsightsPanel,
    createConfig:    {
        group: 'RoomAutomation',
        name: "Window",
        description: "Window",
        panel: OverviewPanel,
        defaultProperties: [
            { key: 'AlarmValue', value: true },
        ]
    },
}
